import BattleCalc from 'dt-common/battle_engine/BattleCalc';
import * as PIXI from 'pixi.js';
import Audio from '~/Audio';
import Colors from '~/constants/Colors';
import { ObjectPool } from '~/Tools';

const _beamPool = new ObjectPool(
  () => {
    const beam = new PIXI.Graphics();
    beam.beginFill(Colors.BRIGHT_YELLOW, 0.3 + Math.random() * 0.5);
    const width = 1 + Math.random() * 2;
    beam.drawRect(-width / 2, -0.5, width, 1);
    beam.endFill();
    beam.cacheAsBitmap = true;
    return beam;
  },
  (beam) => {
    gsap.killTweensOf(beam);
    gsap.killTweensOf(beam.scale);
    beam.parent?.removeChild(beam);
    beam.alpha = 0.7 + Math.random() * 0.3;
    beam.scale.set(1, 1);
  },
  200
);

const SanctuaryRendering = {
  render: function (data, gameBoard, isCaverns) {
    const actorSprite = gameBoard.getAllPieceSprites()[data.actorId];
    const render_movement = !isCaverns || actorSprite.gamePiece.hero;
    const transitTime = render_movement ? actorSprite.puppet.getCooldown() : 0;

    render_movement && actorSprite.puppet.getMovements().magicUpGentle.movePuppet({ transitTime });
  },

  renderResult: function (data, gameBoard, isCaverns) {
    const victimSprite = gameBoard.getAllPieceSprites()[data.victimId];

    for (var uid in gameBoard.getTileSprites()) {
      var tileSprite = gameBoard.getTileSprites()[uid];

      if (
        BattleCalc.boardDistance(tileSprite.gamePiece, victimSprite.gamePiece) <= data.effectRange
      ) {
        var numBeams = 4 + Math.round(Math.random() * 6);
        for (var i = 0; i < numBeams; ++i) {
          var beam = _beamPool.get();

          beam.x = isCaverns
            ? -25 + Math.random() * 50
            : -tileSprite.tileImg.width / 2 + Math.random() * tileSprite.tileImg.width;
          beam.y = -tileSprite.tileImg.height / 2 + Math.random() * tileSprite.tileImg.height;

          const tweenDuration = 0.7 + Math.random() * 2.3;
          TweenMax.to(beam.scale, tweenDuration - 0.2, {
            y: 20 + Math.random() * 70,
            ease: Math.random() < 0.5 ? Quad.easeIn : Expo.easeIn,
          }).delay(i * 0.03);
          TweenMax.to(beam, tweenDuration, {
            y: beam.y - 30 - Math.random() * 30,
            alpha: 0,
            ease: Math.random() < 0.5 ? Quad.easeIn : Expo.easeIn,
            onComplete: _beamPool.put,
            onCompleteParams: [beam],
          }).delay(i * 0.03);
          tileSprite.tileImg.addChild(beam);
        }
      }
    }

    Audio.play('positive_magic_01');
  },
};
export default SanctuaryRendering;
